export const DEFAULT_CRM_TOKEN = 'txvfonosivr';
export const AGENCY_ID = 75;
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandLogoSecondary = `${window.assetsLocation}/images/logo2.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['45'];
export const faqArticleIds = [
    '4',
    '5',
    '7',
    '8',
    '9',
    '10',
    '12',
    '13',
    '14',
    '15',
    '17',
    '19',
    '20',
    '23',
    '39',
];
export const portalHomeUrl = 'https://torrancecoyote.comcate.com/';
export const portalName = 'Coyote Management Portal';
